import React from 'react';
import { DateInput, Filter, SelectInput,SearchInput,minLength,maxLength} from 'react-admin';
import { deviseFiltre, status } from '../references.js';

const FiltreDepense =(props)=> {
/*
    componentDidMount(){
        var  list_camps=[];
        var camps =JSON.parse(localStorage.getItem('camps'));
       
        if(camps){
            camps=camps.filter(item=>item.type==='AERIEN');
            camps=_.orderBy(camps, ['id'],['desc']);
            camps.forEach((item, index) => {
                list_camps[index] = { id: item.id, name: item.code };
            })
        }

        this.setState({list_camps:list_camps},()=>{});
     }
     */

    //const {l_ag_dest,roles}=this.state;
    return (
        <Filter {...props} >
            <SearchInput source="code" alwaysOn  validate={[minLength(4),maxLength(8)]} />
            <DateInput source="start_date" label="Date début"  alwaysOn />
            <DateInput source="end_date" label="Date fin"  alwaysOn />
           
            <SelectInput
                source="status"
                label="Status" 
                choices={status}
                
            />
            <SelectInput
                source="devise"
                label="Devise" 
                choices={deviseFiltre}
            />
            
        </Filter>
    );
}

export default FiltreDepense;